import { Helmet } from 'react-helmet-async'

interface HelmetProps {
  title?: string
  description?: string
  ogTitle?: string
  ogDescription?: string
  ogUrl?: string
}

const TITLE = '미술품 조각 투자 플랫폼 아티피오'
const DESCRIPTION =
  '예스24가 만든 미술품 조각투자 플랫폼 아티피오에서 블루칩 작가의 작품을 함께 소유하고 청약을 통해 나의 자산으로 만들어보세요.'

export function Head({ title, description, ogTitle, ogDescription, ogUrl }: HelmetProps) {
  return (
    <Helmet key={location.pathname}>
      <title>{title ?? TITLE}</title>
      <meta name="description" content={description ?? DESCRIPTION} />
      <meta property="og:title" content={ogTitle ?? DESCRIPTION} />
      <meta property="og:description" content={ogDescription ?? DESCRIPTION} />
      {ogUrl ? <meta property="og:url" content={ogUrl} /> : null}
    </Helmet>
  )
}
